// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppHome_main__Y0d\\+1 {
  display: grid;
  grid-template-columns: 72rem 1fr;
  grid-template-rows: max-content min-content;
  gap: 3rem;
}
.AppHome_main__Y0d\\+1 > :nth-child(3), .AppHome_main__Y0d\\+1 > :nth-child(4) {
  grid-column: 1/3;
}
@media only screen and (max-width: 43.75em) {
  .AppHome_main__Y0d\\+1 > :nth-child(3), .AppHome_main__Y0d\\+1 > :nth-child(4) {
    grid-column: 1/2;
  }
  .AppHome_main__Y0d\\+1 > :nth-child(2) {
    grid-row: 3/4;
  }
}
@media only screen and (max-width: 62.5em) {
  .AppHome_main__Y0d\\+1 {
    grid-template-columns: 60rem 1fr;
  }
}
@media only screen and (max-width: 43.75em) {
  .AppHome_main__Y0d\\+1 {
    grid-template-columns: 100%;
  }
}
.AppHome_main__Y0d\\+1 .AppHome_tagBanner__n\\+Qcy {
  position: absolute;
  z-index: 100;
  top: 1px;
  left: 1px;
}

.AppHome_homeTop__w\\+xdV {
  display: flex;
}
.AppHome_homeTop__w\\+xdV > :not(:last-child) {
  margin-right: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .AppHome_homeTop__w\\+xdV {
    flex-direction: column;
  }
}

.AppHome_multi__W8QV3 {
  width: 38rem;
  background-color: var(--color-white);
  border-radius: 1rem;
  box-sizing: border-box;
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  font-size: var(--default-font-small);
  color: var(--color-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: fit-content;
}
.AppHome_multi__W8QV3 > :first-child {
  cursor: pointer;
}
.AppHome_multi__W8QV3 > :first-child:hover {
  font-weight: 700;
  color: var(--color-primary-4);
}
@media only screen and (max-width: 31.25em) {
  .AppHome_multi__W8QV3 {
    width: 100%;
  }
}
.AppHome_multi_select__hu6NK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  margin-bottom: 1.5rem;
  width: 100%;
  color: var(--color-dark);
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--color-dark);
}
.AppHome_multi_select_close__ha3tz {
  margin-left: 2rem;
  color: var(--color-error);
  font-size: 3rem;
}
.AppHome_multi_biz_list__UzzhG {
  display: flex;
  color: var(--color-dark);
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 1rem;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
}
.AppHome_multi_biz_list__UzzhG:hover {
  background-color: var(--color-primary-4);
  padding: 2rem 1rem;
  color: var(--color-white);
  font-weight: 700;
}
.AppHome_multi_biz_list_active__zlrQn {
  display: flex;
  background-color: var(--color-primary-4);
  color: var(--color-white);
  padding: 2rem 1rem;
  font-weight: 700;
  margin-bottom: 1rem;
  border-radius: 1rem;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
}
.AppHome_multi_biz_list_btns__FGVB2 {
  margin-top: 4rem;
  border-top: 1px solid var(--color-dark);
  padding-top: 2rem;
  width: 100%;
}

.AppHome_topFilter__EHn0v {
  display: flex;
  flex-direction: column;
  background-color: var(--color-white);
  border-radius: 1rem;
  box-sizing: border-box;
  padding: 1.5rem 3rem;
  margin-bottom: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: fit-content;
}
.AppHome_topFilter__EHn0v > :not(last-child) {
  margin-bottom: 2rem;
}

.AppHome_filter__K4jQi {
  width: 100%;
  box-sizing: border-box;
  padding: 1rem 3rem;
  background-color: var(--color-white);
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
}
.AppHome_filter_button__JFZKj {
  display: flex;
  align-items: center;
  color: var(--color-primary);
  cursor: pointer;
  font-size: var(--default-font-small);
}
.AppHome_filter_button__JFZKj:hover {
  color: var(--color-primary-4);
}
.AppHome_filter_button_icon__LUszV {
  font-size: 3rem;
  margin-right: 1rem;
}
.AppHome_filter_line__3lC7b {
  margin-top: 1rem;
  border-top: 1px solid var(--color-primary);
}
.AppHome_filter_content__yUZ-4 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.AppHome_filter_content__yUZ-4 > :not(last-child) {
  margin-right: 1rem;
}

.AppHome_toDo__zEtaX {
  grid-column: 1/3;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3rem 3rem;
  border-radius: 1rem;
}
.AppHome_toDo__group__SJpup {
  display: flex;
  font-size: var(--default-font-small);
  justify-content: space-between;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}
.AppHome_toDo__group__SJpup > :not(last-child) {
  margin-right: 2rem;
}
.AppHome_toDo__items__TYHjs {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.AppHome_toDo__items_hover__13G5O {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: red;
}
.AppHome_toDo__items_hover__13G5O > :not(last-child) {
  margin-right: 1rem;
}
.AppHome_toDo__items_hover__13G5O span {
  font-size: 2.5rem;
}
.AppHome_toDo__items_hover__13G5O:hover {
  color: var(--color-primary);
  font-weight: 700;
}
.AppHome_toDo__items__TYHjs > :not(last-child) {
  margin-right: 1rem;
}
.AppHome_toDo__items__TYHjs span {
  font-size: 2.5rem;
}
.AppHome_toDo__green__eOqOl {
  color: var(--color-success);
}
@media only screen and (max-width: 43.75em) {
  .AppHome_toDo__zEtaX {
    grid-column: 1/2;
  }
}

.AppHome_selectCurrency__nNKx0 {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.AppHome_selectCurrency__text__Nz8Nv {
  display: flex;
}
.AppHome_selectCurrency__icon__pmMqE {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.AppHome_selectCurrency__icon__pmMqE:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.AppHome_selectCurrency__icon_active__w4tpA {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.AppHome_selectCurrency__list__dA\\+AT {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.AppHome_selectCurrency__list_active__K3nSU {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.AppHome_selectCurrency__list__dA\\+AT li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.AppHome_selectCurrency__list__dA\\+AT li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}

.AppHome_expense__9wLDw {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: var(--default-font-h3);
  margin-top: 3rem;
}
.AppHome_expense__9wLDw > :not(:last-child) {
  margin-right: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/AppHome.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,gCAAA;EACA,2CAAA;EACA,SAAA;AADD;AAGC;EAEC,gBAAA;AAFF;AAIE;EAJD;IAKE,gBAAA;EADD;EAKD;IAEE,aAAA;EAFD;AAJF;AAUC;EArBD;IAsBE,gCAAA;EAFA;AACF;AAIC;EAzBD;IA0BE,2BAAA;EADA;AACF;AAGC;EACC,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;AADF;;AAKA;EACC,aAAA;AAFD;AAIC;EACC,kBAAA;AAFF;AAKC;EAPD;IAQE,sBAAA;EAFA;AACF;;AAKA;EACC,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oCAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAFD;AAIC;EACC,eAAA;AAFF;AAGE;EACC,gBAAA;EACA,6BAAA;AADH;AAKC;EAxBD;IAyBE,WAAA;EAFA;AACF;AAIC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,0CAAA;AAFF;AAIE;EACC,iBAAA;EACA,yBAAA;EACA,eAAA;AAFH;AAUE;EACE,aAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;AARJ;AAUI;EACC,wCAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AARL;AAWG;EACC,aAAA;EACA,wCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;AATJ;AAYG;EACC,gBAAA;EACA,uCAAA;EACA,iBAAA;EACA,WAAA;AAVJ;;AAgBA;EACC,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;AAbD;AAeC;EACC,mBAAA;AAbF;;AAiBA;EACC,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;AAdD;AAgBC;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,oCAAA;AAdF;AAgBE;EACC,6BAAA;AAdH;AAiBE;EACC,eAAA;EACA,kBAAA;AAfH;AAmBC;EACC,gBAAA;EACA,0CAAA;AAjBF;AAoBC;EACC,aAAA;EACA,eAAA;EACA,mBAAA;AAlBF;AAmBE;EACC,kBAAA;AAjBH;;AAsBA;EACC,gBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AAnBD;AAqBC;EACC,aAAA;EACA,oCAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAnBF;AAqBE;EACC,kBAAA;AAnBH;AAuBC;EACC,aAAA;EACA,mBAAA;EACA,eAAA;AArBF;AAuBE;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AArBH;AAuBG;EACC,kBAAA;AArBJ;AAwBG;EACC,iBAAA;AAtBJ;AAyBG;EACC,2BAAA;EACA,gBAAA;AAvBJ;AA2BE;EACC,kBAAA;AAzBH;AA4BE;EACC,iBAAA;AA1BH;AA8BC;EACC,2BAAA;AA5BF;AA+BC;EA1DD;IA2DE,gBAAA;EA5BA;AACF;;AA+BA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AA5BD;AA8BC;EACC,aAAA;AA5BF;AA+BC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AA7BF;AA+BE;EACC,4DAAA;EAEA,wCAAA;EACA,2BAAA;AA9BH;AAiCE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DAAA;EAEA,wCAAA;EACA,2BAAA;AAhCH;AAqCC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DAAA;EAEA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AApCF;AAwCE;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AAtCH;AA0CE;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAxCH;AA0CG;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AAxCJ;;AA8CA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;AA3CD;AA6CC;EACC,kBAAA;AA3CF","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\tdisplay: grid;\n\tgrid-template-columns: 72rem 1fr;\n\tgrid-template-rows: max-content min-content;\n\tgap: 3rem;\n\n\t& > :nth-child(3),\n\t& > :nth-child(4) {\n\t\tgrid-column: 1/3;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tgrid-column: 1/2;\n\t\t}\n\t}\n\n\t& > :nth-child(2) {\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tgrid-row: 3/4;\n\t\t}\n\t}\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tgrid-template-columns: 60rem 1fr;\n\t}\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.tagBanner {\n\t\tposition: absolute;\n\t\tz-index: 100;\n\t\ttop: 1px;\n\t\tleft: 1px;\n\t}\n}\n\n.homeTop {\n\tdisplay: flex;\n\t\n\t&>:not(:last-child) {\n\t\tmargin-right: 2rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tflex-direction: column;\n\t}\n}\n\n.multi {\n\twidth: 38rem;\n\tbackground-color: var(--color-white);\n\tborder-radius: 1rem;\n\tbox-sizing: border-box;\n\tpadding: 1.5rem 2rem;\n\tmargin-bottom: 2rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-primary);\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\theight: fit-content;\n\n\t& >:first-child {\n\t\tcursor: pointer;\n\t\t&:hover {\n\t\t\tfont-weight: 700;\n\t\t\tcolor: var(--color-primary-4);\n\t\t}\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\twidth: 100%;\n\t}\n\n\t&_select  {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tfont-weight: 700;\n\t\tmargin-bottom: 1.5rem;\n\t\twidth: 100%;\t\n\t\tcolor: var(--color-dark);\n\t\tpadding-bottom: 0.5rem;\n\t\tborder-bottom: 1px solid var(--color-dark);\n\n\t\t&_close {\n\t\t\tmargin-left: 2rem;\n\t\t\tcolor: var(--color-error);\n\t\t\tfont-size: 3rem;\n\t\t}\n\n\t}\n\n\t&_biz {\n\t\t\n\n\t\t&_list {\n\t\t\t\tdisplay: flex;\n\t\t\t\tcolor: var(--color-dark);\n\t\t\t\tpadding: 1rem;\t\t\t\t\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tcursor: pointer;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\twidth: 100%;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground-color: var(--color-primary-4);\n\t\t\t\t\tpadding: 2rem 1rem;\n\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t}\n\n\t\t\t&_active {\n\t\t\t\tdisplay: flex;\n\t\t\t\tbackground-color: var(--color-primary-4);\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tpadding: 2rem 1rem;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tcursor: pointer;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t&_btns {\n\t\t\t\tmargin-top: 4rem;\n\t\t\t\tborder-top: 1px solid var(--color-dark);\n\t\t\t\tpadding-top: 2rem;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.topFilter {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: var(--color-white);\n\tborder-radius: 1rem;\n\tbox-sizing: border-box;\n\tpadding: 1.5rem 3rem;\n\tmargin-bottom: 2rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\twidth: fit-content;\n\n\t& > :not(last-child) {\n\t\tmargin-bottom: 2rem;\n\t}\n}\n\n.filter {\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tpadding: 1rem 3rem;\n\tbackground-color: var(--color-white);\n\tborder-radius: 1rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tmargin-bottom: 2rem;\n\n\t&_button {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t\tfont-size: var(--default-font-small);\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary-4);\n\t\t}\n\n\t\t&_icon {\n\t\t\tfont-size: 3rem;\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n\n\t&_line {\n\t\tmargin-top: 1rem;\n\t\tborder-top: 1px solid var(--color-primary);\n\t}\n\n\t&_content {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t\t& > :not(last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n}\n\n.toDo {\n\tgrid-column: 1/3;\n\tbackground-color: var(--color-white);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tbox-sizing: border-box;\n\tpadding: 3rem 3rem;\n\tborder-radius: 1rem;\n\n\t&__group {\n\t\tdisplay: flex;\n\t\tfont-size: var(--default-font-small);\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 2rem;\n\t\tflex-wrap: wrap;\n\n\t\t& > :not(last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t}\n\t}\n\n\t&__items {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\n\t\t&_hover {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\t\t\tcolor: red;\n\n\t\t\t& > :not(last-child) {\n\t\t\t\tmargin-right: 1rem;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tfont-size: 2.5rem;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\n\t\t& > :not(last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\tspan {\n\t\t\tfont-size: 2.5rem;\n\t\t}\n\t}\n\n\t&__green {\n\t\tcolor: var(--color-success);\n\t}\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tgrid-column: 1/2;\n\t}\n}\n\n.selectCurrency {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tfont-size: var(--default-font-small);\n\tposition: relative;\n\tmargin-left: 2rem;\n\n\t&__text {\n\t\tdisplay: flex;\n\t}\n\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tfont-size: 3rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-primary);\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\tborder-radius: 5rem;\n\t\tborder: solid 1px var(--color-primary-4);\n\t\tcursor: pointer;\n\t\ttransform: rotateZ(0);\n\t\ttransition-duration: 500ms;\n\n\t\t&:hover {\n\t\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\n\t\t&_active {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\tbackground-color: #f2f0f0;\n\t\t\tcolor: var(--color-primary);\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\tborder-radius: 5rem;\n\t\t\tborder: solid 1px var(--color-primary-4);\n\t\t\tcursor: pointer;\n\t\t\ttransition-duration: 500ms;\n\t\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg)\n\t\t}\n\t\t\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 5rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-dark);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t\t-15px -15px 30px #ffffff;\n\t\tposition: absolute;\n\t\ttop: 6rem;\n\t\tz-index: 30;\n\t\tborder: solid 1px var(--color-primary-4);\n\n\t\t\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t}\n\t\t\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder-radius: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.expense {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-weight: 700;\n\tfont-size: var(--default-font-h3);\n\tmargin-top: 3rem;\n\n\t& > :not(:last-child) {\n\t\tmargin-right: 2rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `AppHome_main__Y0d+1`,
	"tagBanner": `AppHome_tagBanner__n+Qcy`,
	"homeTop": `AppHome_homeTop__w+xdV`,
	"multi": `AppHome_multi__W8QV3`,
	"multi_select": `AppHome_multi_select__hu6NK`,
	"multi_select_close": `AppHome_multi_select_close__ha3tz`,
	"multi_biz_list": `AppHome_multi_biz_list__UzzhG`,
	"multi_biz_list_active": `AppHome_multi_biz_list_active__zlrQn`,
	"multi_biz_list_btns": `AppHome_multi_biz_list_btns__FGVB2`,
	"topFilter": `AppHome_topFilter__EHn0v`,
	"filter": `AppHome_filter__K4jQi`,
	"filter_button": `AppHome_filter_button__JFZKj`,
	"filter_button_icon": `AppHome_filter_button_icon__LUszV`,
	"filter_line": `AppHome_filter_line__3lC7b`,
	"filter_content": `AppHome_filter_content__yUZ-4`,
	"toDo": `AppHome_toDo__zEtaX`,
	"toDo__group": `AppHome_toDo__group__SJpup`,
	"toDo__items": `AppHome_toDo__items__TYHjs`,
	"toDo__items_hover": `AppHome_toDo__items_hover__13G5O`,
	"toDo__green": `AppHome_toDo__green__eOqOl`,
	"selectCurrency": `AppHome_selectCurrency__nNKx0`,
	"selectCurrency__text": `AppHome_selectCurrency__text__Nz8Nv`,
	"selectCurrency__icon": `AppHome_selectCurrency__icon__pmMqE`,
	"selectCurrency__icon_active": `AppHome_selectCurrency__icon_active__w4tpA`,
	"selectCurrency__list": `AppHome_selectCurrency__list__dA+AT`,
	"selectCurrency__list_active": `AppHome_selectCurrency__list_active__K3nSU`,
	"expense": `AppHome_expense__9wLDw`
};
export default ___CSS_LOADER_EXPORT___;
